import React from 'react';
import { createRoot } from 'react-dom/client';
import AToZApp from "@sharedComponents/AToZContainer/AToZApp";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";


const container = document.getElementById('js-atoz-app')!;
const root = createRoot(container);
if (container)
{
    const queryClient = new QueryClient();
    root.render(
        <QueryClientProvider client={queryClient}>
            <AToZApp />
        </QueryClientProvider>        
    ); 
}